var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"listing-image",style:({
        'background-image': ("url(" + _vm.image + ")"),
    }),attrs:{"src":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=","alt":_vm.item.title,"title":_vm.item.title},on:{"error":_vm.loadPlaceholder}})}
var staticRenderFns = []

export { render, staticRenderFns }